import Config from './config'
import Phaser from 'phaser'
import {_setIsMuted} from '../app/app'
import audio from './audio'

const devSound = () =>
    new Promise((resolve, reject) => {
        _setIsMuted(false)

        const camera = Config.scene.cameras.main
        camera.setViewport(
            0,
            0,
            window.screen.width * 3,
            window.screen.height * 3
        )

        camera.setZoom(2)
        camera.centerOn(200, 200)

        class SoundButton {
            constructor({key, x, y}) {
                this.button = Config.scene.add.text(x + 4, y + 4, key, {
                    fill: '#fff',
                })
                this.button.setInteractive()

                this.rect = new Phaser.Geom.Rectangle(x, y, 300, 30)
                this.graphics = Config.scene.add.graphics({
                    lineStyle: {width: 2, color: 0xffffff},
                })
                this.graphics.strokeRectShape(this.rect)

                this.button.on('pointerdown', () => {
                    audio.play(key)
                })
            }
        }

        console.log(
            'Config.scene.cache.audio.entries.entries',
            Config.scene.cache.audio.entries.entries
        )

        let y = 10
        Object.keys(Config.scene.cache.audio.entries.entries).forEach((key) => {
            new SoundButton({
                key,
                x: 10,
                y,
            })
            y += 30
        })

        return resolve()
    })

export default devSound
